module.exports = __webpack_public_path__ + "img/1727166131700-a4a20332-a275-42e7-9dc7-5d1f2a8cd6fc.jpeg.914de24b.webp";